import type { ImageLoadFailureKind } from '@/types/canvas-type';

export type ReaderPageVisualState =
  'loaded' | 'loading' | 'network-error' | 'permanent-error' | 'idle';

/** 将加载 entry 归一成 resize 后需要恢复到新 PixiPage 的视觉状态。 */
export function resolveReaderPageVisualState(entry: {
  hasPage: boolean;
  hasPendingLoad: boolean;
  failureKind?: ImageLoadFailureKind;
}): ReaderPageVisualState {
  if (entry.hasPage) return 'loaded';
  if (entry.hasPendingLoad) return 'loading';
  if (entry.failureKind === 'network') return 'network-error';
  if (entry.failureKind === 'permanent') return 'permanent-error';
  return 'idle';
}
